/**
 * 
 */
import { PublicDigitalServiceShort } from './publicDigitalServiceShort.model';
export class PublicDigitalService extends PublicDigitalServiceShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this._isEmpty = this.isEmpty(this);
    }
}
